/**
 * Builder-only policy — no pricing tiers, quotas, or monetization gates.
 */

import { ALL_WIDGET_TYPE_IDS } from '../builder/widgetTypes.js';

export const BUILDER_POLICY = {
  planId: 'builder',
  displayName: 'Builder',
  maxWidgets: null,
  maxViewsPerMonth: null,
  allowedSports: ['football'],
  allowedWidgetTypes: ALL_WIDGET_TYPE_IDS,
  requiresBranding: false,
  whitelabel: true,
};

export function getPlanPolicy() {
  return BUILDER_POLICY;
}

export function isWidgetTypeAllowed() {
  return true;
}

export function getEmbedPolicy() {
  return BUILDER_POLICY;
}

export function getQuotaPercent() {
  return null;
}

export function isQuotaExceeded() {
  return false;
}

export function isQuotaWarning() {
  return false;
}
